import { Users } from '@platform/client';
import { AuthedPage } from '../app';
import { AdminNav } from './AdminNav';

const Admin = ({ children }: { children: React.ReactNode }) => {
  const { data: user } = Users.useGetCurrentUser();
  const logoutHref = import.meta.env.VITE_API_HOST + '/login/logout';
  return (
    <AuthedPage>
      <div className='flex flex-col overflow-x-auto overflow-y-auto h-[100vh]'>
        <div className='self-end p-2 text-xs'>
          <p className='inline mr-4 text-brand-100'>Logged in as {user?.firstName}</p>
          <a href={logoutHref} className=' text-red-600 hover:underline'>
            Logout
          </a>
        </div>
        <AdminNav />
        <div className='p-4'>{children}</div>
      </div>
    </AuthedPage>
  );
};

export default Admin;
